// extracted by mini-css-extract-plugin
export default {"cls1":"xvXGUSljg6oLhXKmjHPu","cls2":"DPFO5yGeAqMmmLbqsv8B xvXGUSljg6oLhXKmjHPu"};